/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Child-log lookup strategy for a tool usage trace row
 */
export const ToolUsageTraceLogGroupKind = {
  TraceId: "trace_id",
  CorrelationId: "correlation_id",
  TriggerEventId: "trigger_event_id",
  LogId: "log_id",
} as const;
/**
 * Child-log lookup strategy for a tool usage trace row
 */
export type ToolUsageTraceLogGroupKind = OpenEnum<
  typeof ToolUsageTraceLogGroupKind
>;

/**
 * Descriptor used by the dashboard to fetch child logs for a trace row
 */
export type ToolUsageTraceLogGroup = {
  /**
   * Child-log lookup strategy for a tool usage trace row
   */
  kind: ToolUsageTraceLogGroupKind;
  /**
   * Lookup value
   */
  value: string;
};

/** @internal */
export const ToolUsageTraceLogGroupKind$inboundSchema: z.ZodMiniType<
  ToolUsageTraceLogGroupKind,
  unknown
> = openEnums.inboundSchema(ToolUsageTraceLogGroupKind);

/** @internal */
export const ToolUsageTraceLogGroup$inboundSchema: z.ZodMiniType<
  ToolUsageTraceLogGroup,
  unknown
> = z.object({
  kind: ToolUsageTraceLogGroupKind$inboundSchema,
  value: z.string(),
});

export function toolUsageTraceLogGroupFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageTraceLogGroup, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageTraceLogGroup$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageTraceLogGroup' from JSON`,
  );
}
